import React, { createContext, useCallback, useContext, useEffect, useState } from 'react';
import axios from 'axios';

const BrandingContext = createContext({
  logoDataUrl: null,
  loading: true,
  refresh: async () => {},
});

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const BrandingProvider = ({ children }) => {
  const [logoDataUrl, setLogoDataUrl] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const resp = await axios.get(`${BACKEND}/api/branding`);
      setLogoDataUrl(resp.data?.logo_data_url || null);
    } catch (err) {
      // Non-fatal — fall back to text placeholder
      setLogoDataUrl(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return (
    <BrandingContext.Provider value={{ logoDataUrl, loading, refresh }}>
      {children}
    </BrandingContext.Provider>
  );
};

export const useBranding = () => useContext(BrandingContext);

export default BrandingContext;
